export const transformForPDF = (formData) => {
  return {
    title: 'Electrical Installation Condition Report',
    property: {
      address: formData.property.address,
      landlord: formData.property.landlord,
      tenant: formData.property.tenant,
      inspectionDate: new Date(formData.property.inspectionDate).toLocaleDateString('en-GB')
    },
    engineer: {
      name: formData.engineer.engineerName,
      electricalRegNumber: formData.engineer.electricalRegNumber,
      company: formData.engineer.company,
      phone: formData.engineer.phone
    },
    circuits: formData.circuits.map(circuit => ({
      circuitType: circuit.circuitType,
      location: circuit.location,
      rating: circuit.rating,
      protectiveDevice: circuit.protectiveDevice,
      testResult: circuit.testResult,
      remedialAction: circuit.remedialAction,
      status: circuit.testResult === 'Satisfactory' ? 'PASS' : 'FAIL'
    })),
    certification: {
      nextInspectionDate: new Date(formData.certification.nextInspectionDate).toLocaleDateString('en-GB'),
      certificateNumber: formData.certification.certificateNumber,
      engineerSignature: formData.certification.engineerSignature,
      additionalNotes: formData.certification.additionalNotes,
      issueDate: new Date().toLocaleDateString('en-GB')
    }
  };
};